/**
 *  是否可以操作订单
 */
export const canOperateOrder = is_supply_action => {
  return is_supply_action == 1
}
